module.exports = __webpack_public_path__ + "static/media/Vitech2.d39d1fc6.png";